<template>
  <div class="page_">
    <div class="page_title">
      为版权需求方提供安全便利的版权购买方式
    </div>
    <div class="containerStyle1">
      <div class="container_">
        <div class="left_">
          <div>购买的版权经过了确权</div>
          <div>通过龙源版权确权平台通过智能合约购买版权使用权<br />可以放心内容的版权归属和明确使用的权利。</div>
        </div>
        <div class="right_">
          <img src="../../assets/images/staticPage/buyCopyright/img1.png" alt="">
        </div>
      </div>
    </div>
    <div class="containerStyle2">
      <div class="container_">
        <div class="left_">
          <img src="../../assets/images/staticPage/buyCopyright/img2.png" alt="">
        </div>
        <div class="right_">
          <div>按需购买授权类型和时间</div>
          <div>不同的出版方和媒体对内容的版权需求时间不同，从1个月到10年<br />对数十种不同的权利要求也不同，使用智能合约可以精准的获得自己需要的授权，避免版权资源的浪费。</div>
        </div>
      </div>
    </div>
    <div class="containerStyle1">
      <div class="container_">
        <div class="left_">
          <div>降低签约和行政管理成本</div>
          <div>和约稿人使用智能合约，避免了双方的协议签署和版权存储的管理难度；购买过所有的版权使用都可以在账户中备查，无论版权是否已经过期，智能合约证书可以随时下载，证明</div>
        </div>
        <div class="right_">
          <img src="../../assets/images/staticPage/buyCopyright/img3.png" alt="">
        </div>
      </div>
    </div>
    <div class="containerStyle2" style="margin-bottom:69px;">
      <div class="container_">
        <div class="left_">
          <img src="../../assets/images/staticPage/buyCopyright/img4.png" alt="">
        </div>
        <div class="right_">
          <div>龙源版权确权平台是首都版权链战略合作单位</div>
          <div>智能合约附着在首都版权链上，也是迄今和国家司法部门天枰链打通的版权链；如果未来遇到纠纷，可确保智能合约符合司法鉴定要求。</div>
        </div>
      </div>
    </div>
    <marketingPageFooter></marketingPageFooter>
  </div>
</template>

<script>
import { reactive } from "vue";
import marketingPageFooter from '@/components/marketingPageFooter.vue'
// import { useRoute, useRouter } from "vue-router";
// import { useStore } from "vuex";
// import Cookies from "js-cookie";

export default {
  name: "buyCopyright",
  components: {
    marketingPageFooter
  },
  setup(prop) {
    console.log(prop);
    // const route = useRoute();
    // const router = useRouter();
    // const store = useStore();
    let pageData = reactive({

    })
    return {
      pageData
    };
  },
};
</script>
<style lang='scss' scoped>
.page_ {
  .containerStyle1 {
    padding: 38px 0 25px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;

    .container_ {
      width: 976px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left_ {
        width: 464px;
        div:nth-of-type(1) {
          font-size: 36px;
          font-family: AlibabaPuHuiTiB;
          color: #303133;
          font-weight: 700;
          margin-bottom: 16px;
        }

        div:nth-of-type(2) {
          font-size: 18px;
          font-family: AlibabaPuHuiTiR;
          color: #303133;
          line-height: 24px;
          text-align: inherit;
          letter-spacing:.1em;
        }
      }

      .right_ {
        width:464px;
        img{
          width: 100%;
        }
      }
    }
  }
  .containerStyle2 {
    padding: 38px 0 25px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    background: #E4E7ED;

    .container_ {
      width: 976px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .right_ {
        width: 464px;
        div:nth-of-type(1) {
          font-size: 36px;
          font-family: AlibabaPuHuiTiB;
          color: #303133;
          font-weight: 700;
          margin-bottom: 16px;
        }

        div:nth-of-type(2) {
          font-size: 18px;
          font-family: AlibabaPuHuiTiR;
          color: #303133;
          line-height: 24px;
          text-align: inherit;
          letter-spacing:.1em;
        }
      }

      .left_ {
        width:464px;
        img{
          width: 100%;
        }
      }
    }
  }

  .page_title {
    margin: 40px 0 38px;
    text-align: center;
    font-size: 40px;
    font-family: AlibabaPuHuiTiB;
    color: #303133;
    font-weight: 800;
  }
}
</style>
